<template>
  <v-dialog
    v-model="open"
    max-width="80%"
    persistent
    @keydown.esc="open = false"
  >
    <base-material-wizard
      v-model="tab"
      :available-steps="availableSteps"
      :items="tabs"
      @cancel="hide"
      @next="next"
      @prev="tab--"
      :progress="progress"
      :title="$t('NewOrganization')"
    >
      <v-tab-item>
        <v-expansion-panels focusable inset>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h3 class="font-weight-regular">{{ $t("Organization") }}</h3>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <OrganizationData :wizard.sync="wizard" :validator.sync="$v" />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h3 class="font-weight-regular">
                {{ $t("RegionalSettings") }}
              </h3>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <RegionalConfigurationData
                :wizard.sync="wizard"
                :validator.sync="$v"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h3 class="font-weight-regular">{{ $t("Email") }}</h3>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <EmailData :wizard.sync="wizard" :validator.sync="$v" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-tab-item>
      <v-tab-item>
        <RoleData :wizard.sync="wizard" />
      </v-tab-item>
      <v-tab-item>
        <UsersData :wizard.sync="wizard" />
      </v-tab-item>
      <v-tab-item>
        <ContentTypeData :wizard.sync="wizard" />
      </v-tab-item>
    </base-material-wizard>
  </v-dialog>
</template>

<script>
import { required, minValue, email } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import ContentTypeData from '@/components/admin/wizard/ContentTypeData';
import EmailData from '@/components/admin/wizard/EmailData';
import OrganizationData from '@/components/admin/wizard/OrganizationData';
import RegionalConfigurationData from '@/components/admin/wizard/RegionalConfigurationData';
import RoleData from '@/components/admin/wizard/RoleData';
import UsersData from '@/components/admin/wizard/UsersData';
import OrganizationService from '@/services/OrganizationService';
import OrganizationWizard from '@/ecm/models/organizationWizard/OrganizationWizard';
import Utils from '@/ecm/common/Utils';

export default {
    components: {
        ContentTypeData,
        EmailData,
        OrganizationData,
        RegionalConfigurationData,
        RoleData,
        UsersData,
    },
    data() {
        return {
            tab: 0,
            tabs: [
                { text: this.$t('Organization'), icon: 'mdi-domain' },
                { text: this.$t('Roles'), icon: 'mdi-account-group' },
                { text: this.$t('Users'), icon: 'mdi-account-multiple-plus' },
                { text: this.$t('ContentTypes'), icon: 'mdi-folder-open-outline' },
            ],
            availableSteps: [0, 1, 2, 3, 4],
            open: false,
            fileInput: true,
            wizard: new OrganizationWizard(),
            progress: false,
        };
    },
    mixins: [validationMixin],
    validations: {
        wizard: {
            organization: {
                name: { required },
                quota: {
                    required,
                    minValue: minValue(1),
                },
                fullUsersLimit: {
                    required,
                    minValue: minValue(0),
                },
                readonlyUsersLimit: {
                    required,
                    minValue: minValue(0),
                },
                concurrentUsersLimit: {
                    required,
                    minValue: minValue(1),
                },
                registeredDevicesLimit: {
                    required,
                    minValue: minValue(0),
                },
                twoFactorAuthenticationUsersLimit: {
                    required,
                    minValue: minValue(0),
                },
            },
            settings: {
                defaultLanguageId: { required },
                defaultTimezone: { required },
                defaultDateFormat: { required },
                defaultDecimalSeparator: { required },
                defaultThousandSeparator: { required },
            },
            emailSettings: {
                emailAccount: { email },
                emailServer: {},
                emailPassword: {},
                emailPort: { minValue: minValue(1) },
                sendGridApiKey: {},
            },
        },
    },
    computed: {},
    methods: {
        next() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.tab = 0;
                return;
            }
            if (this.tab === this.tabs.length - 1) {
                this.progress = true;
                OrganizationService.create(this.wizard.toDto())
                    .then((result) => {
                        Utils.toast.success(
                            this.$t('Organization') + ' ' + this.$t('CreatedSuccessfullyFem')
                        );
                        this.hide();
                        this.$emit('on-save');
                    })
                    .catch(() => {
                    })
                    .then(() => {
                        //always
                        this.progress = false;
                    });
            } else {
                this.tab++;
            }
        },
        show() {
            this.wizard = new OrganizationWizard(this.$store.getters['account/user']);
            this.wizard.roles[0].name = this.$t('OrganizationAdministrator');
            this.$v.$reset();
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>

<style lang="sass">
.v-card.v-card.v-card--account
  border-color: currentColor
  border-width: 4px
  .v-icon
    color: inherit

.v-card--account,
.v-card--account:before
  border-radius: 50%
</style>
